import fetchApi from "../fetchApi";
import {DEFAULT_LIMIT} from "../../contstants";

export const GetShippingAddresses = async (
    {
       limit = DEFAULT_LIMIT,
       offset = 0,
       name = '',
       ids = '',
       company_id = '',
       office_ids = '',
       isActive = true,
       created_on_gte = '',
       created_on_lte = '',
   }) => {
    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/shipping-addresses?limit=${limit}&offset=${offset}&name=${name}&ids=${ids}&company_ids=${company_id}&office_ids=${office_ids}&is_active=${isActive}&created_on_gte=${created_on_gte}&created_on_lte=${created_on_lte}`, options);
}